import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
              爱情岛亚洲
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href={siteInfo.socialMedia.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href={siteInfo.socialMedia.instagram} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href={siteInfo.socialMedia.youtube} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a href={siteInfo.socialMedia.tiktok} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="TikTok">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">资讯中心</Link></li>
              <li><Link to="/category/program-news" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">节目资讯</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              热门栏目
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/program-news" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">嘉宾阵容</Link></li>
              <li><Link to="/category/behind-scenes" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">幕后花絮</Link></li>
              <li><Link to="/category/apply-guide" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">报名指南</Link></li>
              <li><Link to="/category/deep-dive" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">深度观察</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line"></i>
                <span>{siteInfo.contactPhone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.contactEmail}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 爱情岛亚洲 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}